import React from 'react';
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';
import _ from 'lodash';
import { ThemeConfig } from './theme';
import DEFAULT_THEME from './default';

type Props = React.PropsWithChildren<{
  theme?: ThemeConfig | ThemeConfig[];
}>;

const ThemeProvider: React.FC<Props> = ({ children, theme }) => {
  const defaultTheme = _.cloneDeep(DEFAULT_THEME);
  const resolvedTheme: ThemeConfig = Array.isArray(theme)
    ? _.merge(defaultTheme, ...theme)
    : _.merge(defaultTheme, theme);

  return (
    <EmotionThemeProvider theme={resolvedTheme}>
      {children}
    </EmotionThemeProvider>
  );
};

export default ThemeProvider;
